// Compute a 1-2 character initial for a comment author. Prefers firstName +
// lastName initials when both are present; otherwise falls back through
// firstName → lastName → email local-part → '?'. Always returns uppercase.
export const getInitial = (a) => {
    var _a, _b, _c;
    if (!a)
        return '?';
    const first = ((_a = a.firstName) !== null && _a !== void 0 ? _a : '').trim();
    const last = ((_b = a.lastName) !== null && _b !== void 0 ? _b : '').trim();
    if (first && last)
        return (first[0] + last[0]).toUpperCase();
    if (first)
        return first[0].toUpperCase();
    if (last)
        return last[0].toUpperCase();
    const email = ((_c = a.email) !== null && _c !== void 0 ? _c : '').trim();
    if (email && email[0] !== '@')
        return email[0].toUpperCase();
    return '?';
};
// Human-readable name for the same source: full name when known, otherwise the
// email, otherwise 'Unknown'. Used wherever a face is labelled.
export const getDisplayName = (a) => {
    var _a, _b, _c;
    if (!a)
        return 'Unknown';
    const full = `${(_a = a.firstName) !== null && _a !== void 0 ? _a : ''} ${(_b = a.lastName) !== null && _b !== void 0 ? _b : ''}`.trim();
    return full || ((_c = a.email) !== null && _c !== void 0 ? _c : '').trim() || 'Unknown';
};
